/*###########################################################################
// Scroll to
//#########################################################################*/

export const scrollTo = (scrollTarget, offset = 0, after) => {
	const self = this

	let scrollTop = (window.pageYOffset !== undefined) ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop
	let scrollDistance = 0

	if (scrollTarget instanceof Element) {
		let elementTop = scrollTarget.getBoundingClientRect().top
		scrollDistance = elementTop + scrollTop + offset
	} else if (Number.isInteger(scrollTarget)) {
		scrollDistance = scrollTarget + scrollTop + offset
	}

	window.scroll({
		top: scrollDistance,
		left: 0,
		behavior: 'smooth'
	})

	// If after function is set then handle function call
	//
	if (after !== undefined) {
		setTimeout(function() {
			after(self)
		}, 1000)
	}
}
